import React from 'react';
import { useState } from 'react';

/** 
 *  *** EXERCISE 3 ***
 *  
 *  Simple form provided for Exercise 3. Modify this component so that: 
 *  1. The values can be extracted from the form and validated.
 *  2. Display a validation error message (<ValidationError />) if validation fails
 *  3. OR display a success message if the form was submitted (<FormSubmitted />)
 */
function ValidationAnswer() {

    const [state, setState] = useState('');
    const [region, setRegion] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleClientAndServerSubmit = async () => {

        // Validate on the Client sider before sending request to API.
        if (!state.trim() && !region.trim()) {
            setSuccess("");
            setError("Please fill out at least one field.")
            return;
        }

        setError(""); // Clear any previous validation errors before submitting.

        try {
            const response = await fetch('/api/validation', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    state, region
                })
            });
            // Display validation message returned by the server.
            if (!response.ok) {
                setSuccess("");
                setError("Please fill out at least one field.");
                return;
            }

        } catch (error) {
            setError("Unable to submit form.")
        }

        setSuccess("Form has been submitted!");
    

    }

    // Submit directly to backend without performing Client-side validation.
    const handleServerSubmit = async () => {

        try {
            const response = await fetch('/api/validation', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    state, region
                })
            });
            // Display validation message returned by the server.
            if (!response.ok) {
                setSuccess("");
                setError("Please fill out at least one field.");
                return;
            }

            setError(""); // Clear any previous validation errors before submitting.

        } catch (error) {
            setError("Unable to submit form.")
        }
        setSuccess("Form has been submitted!");
    }



    return <div>
        {error && <ValidationError error={error} />}
        {success && <FormSubmitted success={success} />}
        <form>
            <div className="form-group">
                <label htmlFor="state">State</label>
                <select id="state" className="form-control"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                >
                    <option value=""></option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                </select>
            </div>
            <div className="form-group">
                <label htmlFor="region">Region:</label>
                <input type="text" id="region" className="form-control"
                    value={region}
                    onChange={(e) => setRegion(e.target.value)} />
            </div>
            <button type="button"
                onClick={handleClientAndServerSubmit}
                
                className="btn btn-primary" id="btn-submit">Submit (Client + Server)</button>&nbsp;
            <button type="button"
                onClick={handleServerSubmit}
                className="btn btn-primary" id="btn-submit-server-only">Submit (Server Only)</button>
        </form>
    </div>
}



/** Use this component to show client/server validation errors. */
function ValidationError({ error }) {
    return <div className="alert alert-danger">{error}</div>
}

/** Use this component to display a success message after validation passes and the form is submitted. */
function FormSubmitted() {
    return <div className="alert alert-success">Form submitted successfully.</div>
}

/** DO NOT MODIFY */
export function Validation() {
    return <div>
        <h1>Exercise 3 - Validation</h1>
        <p>Please add validation to the form below to achieve the following:</p>
        <ul>
            <li>If both fields are filled out, then an error should NOT appear.</li>
            <li>If one field is filled out, then an error should NOT appear.</li>
            <li>If neither field is filled out, then an error should appear.</li>
        </ul>

        <p>Please perform validation on the server (backend), and also on the client (JavaScript). There are buttons provided for each type, to make it easier for the reviewer to check each one.</p>
        <p>Please implement your server-side validation on the Submit action method in TestApiController.cs</p>

        <ValidationAnswer />
    </div>
}